import { styled } from "styled-components";
import { AnimatePresence, motion } from "framer-motion";
import { Colors } from "../constants";
import CharacterBio from "./CharacterBio";
import CharacterStats from "./CharacterStats";
import CharacterActions from "./CharacterActions";
import TabBar from "./TabBar";

const Sheet = styled(motion.div)`
  width: 100%;
  height: 100%;
  max-width: 1024px;
  display: flex;
  flex-direction: row;
  background: ${Colors.Tan};
  border-radius: 32px;
  padding: 32px;
  gap: 32px;
  flex: 1;
  @media (max-width: 800px) {
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border-radius: 16px;
  }
`;

const Wrapper = styled.div`
  padding: 0 32px 32px;
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 800px) {
    padding: 0 16px 16px;
  }
`;

const CharacterSheet = ({ character, rollDie, currentTab, setCurrentTab }) => {
  return (
    <Wrapper>
      <AnimatePresence mode="wait">
        <Sheet
          initial={{ opacity: 0, translateY: 20 }}
          animate={{ opacity: 1, translateY: 0 }}
          exit={{ opacity: 0, translateY: 20 }}
          transition={{ type: "ease-out", duration: 0.25 }}
        >
          <TabBar currentTab={currentTab} setCurrentTab={setCurrentTab} />
          <CharacterBio character={character} currentTab={currentTab} />
          <CharacterStats
            character={character}
            rollDie={rollDie}
            currentTab={currentTab}
          />
          <CharacterActions
            character={character}
            rollDie={rollDie}
            currentTab={currentTab}
          />
        </Sheet>
      </AnimatePresence>
    </Wrapper>
  );
};

export default CharacterSheet;
